// Header organism component
import { useState } from "react";
import { Icon } from "../atoms";
import { scrollToSection } from "../../utils/scroll";
import { NAV_ITEMS } from "../../utils/constants";

export const Header = ({ donationEnabled = true }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navItems = donationEnabled ? NAV_ITEMS : NAV_ITEMS.filter((s) => s !== "donate");

  const handleNavClick = (section) => {
    scrollToSection(section);
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-paper/95 backdrop-blur-sm border-b border-terracotta-100 shadow-soft">
      <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
        {/* Logo / Brand */}
        <h1 className="font-display text-xl font-semibold text-ink flex items-center gap-2 tracking-tight">
          <Icon size="lg" className="text-terracotta-600">
            ✝
          </Icon>
          Compassion for Widows
        </h1>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((section) => (
            <button
              key={section}
              onClick={() => handleNavClick(section)}
              className="text-sm font-medium text-ink-soft capitalize tracking-wide hover:text-terracotta-600 transition-colors duration-200 relative group"
            >
              {section}
              <span className="absolute -bottom-0.5 left-0 w-0 h-px bg-terracotta-600 group-hover:w-full transition-all duration-200" />
            </button>
          ))}
        </nav>

        {/* Mobile Hamburger Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-ink-soft hover:text-terracotta-600 hover:bg-terracotta-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-terracotta-300"
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
        >
          <span className="text-xl leading-none">
            {mobileMenuOpen ? "✕" : "☰"}
          </span>
        </button>
      </div>

      {/* Mobile Menu Drawer */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-paper border-t border-terracotta-100 shadow-lift">
          <nav className="flex flex-col py-3 max-w-6xl mx-auto px-4">
            {navItems.map((section) => (
              <button
                key={section}
                onClick={() => handleNavClick(section)}
                className="px-4 py-3.5 text-left capitalize text-base font-medium text-ink-soft hover:text-terracotta-600 hover:bg-terracotta-50 rounded-md transition-colors duration-150"
              >
                {section}
              </button>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};
